import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { purifier } from '../../../utils/dom';
import { imageSizeTranslation } from '../../../utils/image';
import { prefix } from '../../../utils/locale';
import { cleanInternalLinks } from '../../../utils/string';
import s from './Image.scss';

const Image = ({ content = {}, attrs = {}, setup, column = 'full', extraProps = {}, tags = [], imageWidth = false, lazyLoad }) => {
	let Wrapper = ({ children }) => children;
	if (attrs?.href) {
		const externalLink = /^(https?|mailto|tel)/.test(attrs.href);
		const anchorLink = /^#/.test(attrs.href);

		if (attrs.target || externalLink || anchorLink) {
			Wrapper = ({ children }) => (
				<a className={s.link} href={attrs.href} target="_blank" rel="noopener noreferrer">
					{ children }
				</a>
			);
		} else {
			Wrapper = ({ children }) => (
				<Link className={s.link} to={prefix(setup, cleanInternalLinks(attrs.href))}>
					{ children }
				</Link>
			);
		}
	}

	if (attrs.borderWidth) {
		extraProps.style = {
			borderWidth: attrs.borderWidth.map((w) => {
				if (setup.breakPoint === 'desktop') return w;
				return w.replace(/(\d+)(.*)/, (...a) => {
					const [, size, units] = a;
					return `${parseInt(size * 0.6, 10)}${units}`;
				});
			}).join(' '),
		};
	}

	let setPortrait = false;
	if (tags.indexOf('wideSpacing') !== -1 && column === 6 && content.image.width <= content.image.height) {
		setPortrait = true;
	}

	return (
		<Wrapper>
			<figure className={[s.image, (setPortrait ? s.image__portrait : null), (content.caption && content.caption.rawText.toLowerCase().indexOf('look') === 0 ? 'u_link' : null)].join(' ')}>
				{ content.image.url && <LazyImage {...imageSizeTranslation(column, content.image, '-', lazyLoad, false, imageWidth)} className={['js-lazyLoad', s.image_image]} {...extraProps} /> }
				{ content.caption && <figcaption className={s.image_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
			</figure>
		</Wrapper>
	);
};

export default hot(module)(Image);
